import { assert_equal, assert_false, assert_string_hash_sha256, assert_true, not_implemented_type, wrong_case } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { UTILS__crypto } from '@shared/utils/crypto/UTILS__crypto';
import { ENUM__field_kind } from '../../_enums/ENUM__field_kind';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { FIELD__base } from './FIELD__base';
import { PROPS__serialization_hashing } from './FIELD__base.store';

declare module './FIELD__base' {
  interface FIELD__base {
    hash__clear(graph: DTO_GRAPH__instance): void;

    hash__set_to_empty(graph: DTO_GRAPH__instance): void;

    hash__update_with_graph(graph: DTO_GRAPH__instance): void;

    /*
     *
     */

    hash__create__case_input__data_source(graph: DTO_GRAPH__instance): [string, string];

    hash__create__case_input__data_linked(graph: DTO_GRAPH__instance): [string, string];

    hash__create__case_input__only_core(graph: DTO_GRAPH__instance): string;

    hash__create__case_input__only_full(hash_core: string): string;

    /*
     *
     */

    hash__create__case_output(graph: DTO_GRAPH__instance): [string, string];

    hash__get_hashed_children(graph: DTO_GRAPH__instance): FIELD__base[];
  }
}

export function INIT_EXTENSION_FIELD_BASE__hash() {
  // do nothing
}

/*
 * CREATE
 */

FIELD__base.prototype.hash_create = function (): string {
  wrong_case();
};

FIELD__base.prototype.hash__clear = function (graph: DTO_GRAPH__instance) {
  if (!this.meta.field_hash__calculated) return;

  this.meta.field_hash__value_full = ENUM__string_id_empty.HASH_SHA256;
  this.meta.field_hash__value_core = ENUM__string_id_empty.HASH_SHA256;
  this.meta.field_hash__value_clean = ENUM__string_id_empty.HASH_SHA256;

  this.meta.field_hash__calculated = false;
};

FIELD__base.prototype.hash__set_to_empty = function (graph: DTO_GRAPH__instance) {
  this.hash__clear(graph);

  this.meta.field_hash__calculated = true;
};

FIELD__base.prototype.hash__update_with_graph = function (graph: DTO_GRAPH__instance) {
  if (this.meta.field_hash__calculated) return; //field already hashed

  this.meta.field_hash__calculated = true;

  let [hash_full, hash_core] = [ENUM__string_id_empty.HASH_SHA256, ENUM__string_id_empty.HASH_SHA256];

  switch (this.meta.field_kind) {
    case ENUM__field_kind.INPUT:
      [hash_full, hash_core] = this.meta.data__is_linked
        ? this.hash__create__case_input__data_linked(graph)
        : this.hash__create__case_input__data_source(graph);

      break;
    case ENUM__field_kind.OUTPUT:
      [hash_full, hash_core] = this.hash__create__case_output(graph);
      break;
    default:
      not_implemented_type(this.meta.field_kind);
  }

  this.meta.field_hash__value_full = hash_full;
  this.meta.field_hash__value_clean = hash_full; //todo: figure out how to calc clean hash, mb need return tuple: hash + hash clean
  this.meta.field_hash__value_core = hash_core;
};

/*
 *
 */

FIELD__base.prototype.hash__create__case_input__data_linked = function (graph: DTO_GRAPH__instance): [string, string] {
  assert_true(this.meta.data__is_linked);
  assert_equal(this.meta.field_kind, ENUM__field_kind.INPUT);

  let field_source = this.find_source(graph);
  field_source.hash__update_with_graph(graph);

  let out_core = field_source.meta.field_hash__value_core;

  let out_full = this.hash__create__case_input__only_full(out_core);

  return [out_full, out_core];
};

FIELD__base.prototype.hash__create__case_input__data_source = function (graph: DTO_GRAPH__instance): [string, string] {
  assert_false(this.meta.data__is_linked);
  assert_true(this.meta.data__is_validated);
  assert_true(this.meta.errors.is_empty());
  assert_false(this.is_stub());

  let [out_full, out_core] = [ENUM__string_id_empty.HASH_SHA256, ENUM__string_id_empty.HASH_SHA256];

  out_core = this.hash__create__case_input__only_core(graph);

  /*
   *
   */

  if (graph.node_and_field__has_effect_on_generation_runtime(this)) {
    out_full = this.hash__create__case_input__only_full(out_core);
  }

  return [out_full, out_core];
};

FIELD__base.prototype.hash__create__case_input__only_core = function (graph: DTO_GRAPH__instance) {
  assert_false(this.meta.data__is_linked);
  assert_true(this.meta.kind__is_input);

  /*
   *
   */

  if (!this.has_effect_on_generation_runtime(graph)) return ENUM__string_id_empty.HASH_SHA256;

  /*
   *
   */

  if (!this.meta.field_hash__value_core.is_empty_hash_sha256()) return this.meta.field_hash__value_core; //already calculated

  let data = this.store__serialize(graph, PROPS__serialization_hashing);

  if (data.is_empty() || data.is_stub()) {
    return ENUM__string_id_empty.HASH_SHA256;
  }

  let data_object = data.to_object();

  let data_object_sorted = Object.sort_keys_recursively(data_object);

  let data_string = JSON.stringify(data_object_sorted);

  let out = UTILS__crypto.sha256.from_string(data_string);

  return out;
};

FIELD__base.prototype.hash__create__case_input__only_full = function (hash_core: string): string {
  assert_string_hash_sha256(hash_core);

  if (hash_core.is_empty_hash_sha256()) return ENUM__string_id_empty.HASH_SHA256;

  /*
   *
   */

  let values: string[] = this.hash_base_values;
  assert_false(values.is_empty());

  /*
   *
   */

  values.push(`field__data=${hash_core}`);

  /*
   *
   */

  values.sort();

  /*
   *
   */
  let out = UTILS__crypto.sha256.from_string(values.join('|'));

  return out;
};

/*
 *
 */

FIELD__base.prototype.hash__create__case_output = function (graph: DTO_GRAPH__instance): [string, string] {
  assert_false(this.meta.data__is_linked);

  assert_true(this.meta.data__is_validated);
  assert_true(this.meta.errors.is_empty());
  assert_false(this.is_stub());

  /*
   * CHILDREN
   */

  /*
   * BODY
   */

  let node = graph.node__get(this.meta.node_id);

  let out_full = node.hash__create_for_field_output(this, graph);

  return [out_full, out_full];
};

FIELD__base.prototype.hash__get_hashed_children = function (graph: DTO_GRAPH__instance) {
  let out = this.fields__get_map(false).values();
  out = out.filter(field => !field.is_stub()); //skip optional fields

  for (const field of out) field.hash__update_with_graph(graph);

  out = out.filter(field => !field.meta.field_hash__value_full.is_empty_hash_sha256()); //skip with empty hashes
  out = out.filter(field => field.meta.generation__has_effect_static); //keep only significant fields

  return out;
};
